import React from "react";

import { LanguageKey } from "@/types/generated/LanguageKey";
import NoDataIcon from "./no-data-available.svg";
import { translate } from "@/hooks/useLanguage";

interface NoDataContainerProps {
  noDataText?: string;
  className?: string;
  loading?: boolean;
}

const NoDataContainer: React.FC<NoDataContainerProps> = ({
  noDataText,
  className = "",
  loading = false,
}) => {

  if (loading) return <></>;

  return (
    <div
      className={`d-flex flex-column align-items-center justify-content-center ${className}`}
    >
      <div>
        <img src={NoDataIcon} alt="" />
      </div>
      <div>{noDataText || translate(LanguageKey.empty_table_key)}</div>
    </div>
  );
};

export default NoDataContainer;
